import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EventData } from '../../providers/event';

@Pipe({
    name: 'categoriesStaff'
})

export class CategorieStaffDataPipe implements PipeTransform {

    constructor(
        private eventData: EventData
    ) { }

    transform(value: string, clientId: string): Observable<any> {
        return this.eventData.getCategorieStaffData(clientId, value);
    }
}


// WEBPACK FOOTER //
// ./src/pipes/staff/staffCategory.ts